import { ProductCategoryEditForm } from './EditProductCategory';
import { hasUserPermission } from '../utils/userPermissions';
import { faTags } from '@fortawesome/free-solid-svg-icons';
import CreateRecordModal from '../components/CreateRecordModal';
import PermissionGate from '../components/PermissionGate';
import React, { useState } from "react";
import { Alert, Button } from '@themesberg/react-bootstrap';
import { PageProductCategoriesTable } from "../components/Tables";
import { ProductCategoryForm } from "./CreateProductCategory";
import { Link } from 'react-router-dom';

export default () => {
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [isCreating, setIsCreating] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [isUpdating, setIsUpdating] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);
  const [creationMessage, setCreationMessage] = useState("");

  const closeCreateModal = () => {
    if (!isCreating) setShowCreateModal(false);
  };

  const handleCategoryCreated = (result) => {
    setShowCreateModal(false);
    setCreationMessage(result.message || 'Product category created successfully.');
    setRefreshKey(value => value + 1);
  };

  const openEditModal = id => {
    if (!hasUserPermission('product_categories', 'edit')) return;
    setCreationMessage('');
    setEditingId(id);
  };

  const closeEditModal = () => {
    if (!isUpdating) setEditingId(null);
  };

  const handleUpdated = result => {
    setEditingId(null);
    setCreationMessage(result.message || 'Product category updated successfully.');
    setRefreshKey(value => value + 1);
  };

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-3">
        <div className="my-auto">
          <h2 className="page-breadcrumb">Product Categories</h2>
        </div>
        <div className="d-flex flex-wrap gap-2 justify-content-end">
          <PermissionGate module="product_categories" action="add"><Button
            variant="primary"
            className="btn-quote-blue d-inline-flex align-items-center py-2 px-3 box-shedow-none outline-none"
            onClick={() => { setCreationMessage(""); setShowCreateModal(true); }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-plus-circle me-1"><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="16"></line><line x1="8" y1="12" x2="16" y2="12"></line></svg>
            Create Product Category
          </Button></PermissionGate>
          <Link to="/principals" className="text-decoration-none btn-quote-back d-inline-flex align-items-center">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-arrow-left-circle me-1">
              <circle cx="12" cy="12" r="10"></circle>
              <polyline points="12 8 8 12 12 16"></polyline>
              <line x1="16" y1="12" x2="8" y2="12"></line>
            </svg>
            Back to Principal Listing
          </Link>
        </div>
      </div>

      {creationMessage && (
        <Alert variant="success" dismissible onClose={() => setCreationMessage("")}>
          {creationMessage}
        </Alert>
      )}

      <div className="my-auto">
        <PageProductCategoriesTable refreshKey={refreshKey} onEditProductCategory={openEditModal} />
      </div>

      <CreateRecordModal
        show={showCreateModal}
        onHide={closeCreateModal}
        isSubmitting={isCreating}
        titleId="create-product-category-title"
        title="Create Product Category"
        description="Create a product category and link it to a principal."
        icon={faTags}
        size="lg"
      >
        {showCreateModal && (
          <ProductCategoryForm
            onSuccess={handleCategoryCreated}
            onCancel={closeCreateModal}
            onSubmittingChange={setIsCreating}
            menuPortalTarget={null}
          />
        )}
      </CreateRecordModal>

      <CreateRecordModal
        show={editingId !== null}
        onHide={closeEditModal}
        isSubmitting={isUpdating}
        titleId="edit-product-category-title"
        title="Edit Product Category"
        description="Update the product category and its principal."
        icon={faTags}
        size="lg"
      >
        {editingId !== null && (
          <ProductCategoryEditForm key={editingId} productCategoryId={editingId}
            onSuccess={handleUpdated} onCancel={closeEditModal} onSubmittingChange={setIsUpdating} />
        )}
      </CreateRecordModal>
    </>
  );
};
